import { contact } from '@/lib/portfolio';
import { cn } from '@/lib/utils';
import { GitHubIcon, LinkedInIcon, XIcon } from './BrandIcons';

const iconMap = {
  github: GitHubIcon,
  linkedin: LinkedInIcon,
  x: XIcon,
} as const;

interface SocialLinksProps {
  className?: string;
  withLabels?: boolean;
}

export function SocialLinks({ className, withLabels = false }: SocialLinksProps) {
  return (
    <div className={cn('flex flex-wrap items-center gap-2.5', className)}>
      {contact.socials.map((social) => {
        const Icon = iconMap[social.icon];
        return (
          <a
            key={social.label}
            href={social.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${social.label} — ${social.handle}`}
            className={cn(
              'flex items-center gap-2 rounded-full border border-white/10 bg-white/5 text-muted-foreground transition-all duration-300',
              'hover:-translate-y-0.5 hover:border-nova/60 hover:text-foreground hover:shadow-[0_0_30px_-8px_hsl(14_95%_60%/0.5)]',
              withLabels ? 'px-4 py-2 text-sm' : 'p-2.5',
            )}
          >
            <Icon className="size-4" />
            {withLabels && <span>{social.label}</span>}
          </a>
        );
      })}
    </div>
  );
}
